import React, { useState } from 'react';
import { BookOpen, ChevronLeft, ChevronRight } from 'lucide-react';
function ImageCarousel() {
  const images = ['https://cdn.magicpatterns.com/uploads/xeyiXvGo5cFJYcFXH7cpdf/El-Cerebro-Adolescente-y-la-Presion-Competitiva.png', 'https://cdn.magicpatterns.com/uploads/apEGyMfLeuZzwuzUNmVe58/Test-Estoy-Presionando-sin-Darme-Cuenta.png', 'https://cdn.magicpatterns.com/uploads/h1FSLfu6fXPEZXc9UjDscR/Como-Piensa-Realmente-Tu-Hijo-Despues-de-un-Partido.png', 'https://cdn.magicpatterns.com/uploads/vT4itUKyiaBqHau3pAFLoX/Padres-Conscientes-vs-Padres-Reactivos.png', 'https://cdn.magicpatterns.com/uploads/1XqogTwmGAKZKH9kNXyUU2/La-Psicologia-Detras-de-las-Palabras.png'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  return <div className="mt-16 max-w-4xl mx-auto" data-id="element-143">
      <h3 className="text-2xl font-black text-gray-900 text-center mb-8 uppercase" data-id="element-144">
        👀 MIRÁ EL MATERIAL POR DENTRO
      </h3>

      <div className="relative group" data-id="element-145">
        <div className="overflow-hidden rounded-xl shadow-2xl border border-gray-200 bg-white aspect-[3/4] md:aspect-video" data-id="element-146">
          <img src={images[currentIndex]} alt={`Vista previa del material ${currentIndex + 1}`} className="w-full h-full object-contain" data-id="element-147" />
        </div>

        <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition" aria-label="Anterior" data-id="element-148">
          <ChevronLeft className="w-6 h-6" data-id="element-149" />
        </button>

        <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition" aria-label="Siguiente" data-id="element-150">
          <ChevronRight className="w-6 h-6" data-id="element-151" />
        </button>

        <div className="flex justify-center gap-2 mt-4" data-id="element-152">
          {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition ${index === currentIndex ? 'bg-green-600' : 'bg-gray-300'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-153" />)}
        </div>
      </div>
    </div>;
}
export function ProductBreakdown() {
  const tomos = [{
    title: 'La mente del futbolista adolescente',
    desc: 'Cómo piensa, siente y reacciona bajo presión competitiva.'
  }, {
    title: 'Comunicación estratégica para padres',
    desc: 'Qué decir en cada momento clave.'
  }, {
    title: 'Autoestima y confianza deportiva',
    desc: 'Construcción de seguridad interna real.'
  }, {
    title: 'Frustración y resiliencia competitiva',
    desc: 'Cómo prevenir el abandono deportivo.'
  }, {
    title: 'Cultura familiar deportiva',
    desc: 'Crear un entorno emocional fuerte.'
  }];
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-154">
      <div className="max-w-5xl mx-auto" data-id="element-155">
        <div className="text-center mb-12" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4 uppercase" data-id="element-157">
            📦 QUÉ INCLUYE EL PROGRAMA
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-158">
            📚 SISTEMA COMPLETO — 5 TOMOS
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-159">
          <div className="order-2 md:order-1" data-id="element-160">
            <h3 className="text-2xl font-bold text-blue-900 mb-6 flex items-center gap-2" data-id="element-161">
              <BookOpen className="w-8 h-8" data-id="element-162" />
              📘 LOS 5 TOMOS
            </h3>
            <div className="space-y-4" data-id="element-163">
              {tomos.map((tomo, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-blue-500" data-id="element-164">
                  <span className="font-black text-blue-900 block mb-1" data-id="element-165">
                    TOMO {i + 1}
                  </span>
                  <p className="font-bold text-gray-900" data-id="element-166">{tomo.title}</p>
                  <p className="text-gray-600 text-sm" data-id="element-167">{tomo.desc}</p>
                </div>)}
            </div>
          </div>

          <div className="order-1 md:order-2 flex flex-col items-center" data-id="element-168">
            <a href="#precio" data-id="element-169">
              <img src="https://cdn.magicpatterns.com/uploads/jxgEKvXjgSs49n8pfpjYvG/MOCKUP_FUTBOL.png" alt="Colección Completa" className="w-full max-w-md drop-shadow-2xl transform hover:scale-105 transition duration-500" data-id="element-170" />
            </a>
          </div>
        </div>

        <ImageCarousel data-id="element-171" />
      </div>
    </section>;
}